module.exports = "/_next/static/images/TankerM-a2449c212be1ebda45a37c2f5379cc19.svg";